// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_HistoricoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /aniversariantes/historico/{cliente_id}
 *
 * Returns history of birthday message sends for a customer.
 */
import type { Aniversariantes_HistoricoRow } from './Aniversariantes_HistoricoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Aniversariantes_HistoricoResponseDados = Aniversariantes_HistoricoRow[];

export type Aniversariantes_HistoricoResponse = ApiResponse<Aniversariantes_HistoricoResponseDados>;

registerResponseContract('Aniversariantes_HistoricoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_aniversario_envio_id: { type: 'number',  required: true },
      cliente_id:                   { type: 'number',  required: true },
      unidade_franquia_id:          { type: 'number',  required: true },
      data_aniversario:             { type: 'string',  required: true },
      data_envio:                   { type: 'string',  required: false },
      mensagem_enviada:             { type: 'string',  required: false },
      status:                       { type: 'string',  required: false },
      whatsapp_mensagem_id:         { type: 'number',  required: false },
      created_at:                   { type: 'string',  required: false },
      deleted_at:                   { type: 'string',  required: false },
    },
  },
})
